<template>
  <div class="svoi-breadcrumbs">
    <div v-for="(item, idx) in items" :key="idx" class="item">
      <SvoiIcon icon="arrow/arrow-right-3" size="xs" class="icon" />
      <template v-if="item.link">
        <NuxtLink v-if="componentType === 'NuxtLink'" class="title" :to="item.link">{{ item.title }}</NuxtLink>
        <a v-else class="title" :href="item.link">{{ item.title }}</a>
      </template>
      <template v-else>
        <span class="title">{{ item.title }}</span>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi'
import { SvoiIcon } from '@svoi-ui/components/icon'
import type { BreadcrumbItem } from '@svoi-ui/interfaces/breadcrumbs'
import { LinkTypes, LinkTypesEnum } from '@svoi-ui/interfaces/link-type'
import { isString } from '@svoi-ui/shared/utils/guards'

export default defineComponent({
  name: 'SvoiBreadcrumbs',
  components: { SvoiIcon },
  props: {
    items: {
      type: Array as PropType<Array<BreadcrumbItem>>,
      default: [] as Array<BreadcrumbItem>
    },
    componentType: {
      type: String as PropType<LinkTypes | string>,
      default: LinkTypesEnum.nuxtLink,
      validator: (value: unknown) => {
        return isString(value) && [LinkTypesEnum.a.toString(), LinkTypesEnum.nuxtLink.toString()].includes(value)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@svoi-ui/assets/scss/components/breadcrumbs';
</style>
